<script>
  import Button from "../../Shared/Button.svelte"
  import PreviewShapes from "./previewShapes.svelte"
  import BadgeState from "../../Stores/badgeState"
  import { onMount } from "svelte"
  export let operation

  let maintainAspectRatio = true
  let aspectRatio = 1

  onMount(() => {
    aspectRatio = operation.width / operation.height
  })

  // let scale = operation.scale

  // operation.inputY = $BadgeState.baseInfo.height - operation.y
  $: operation.x = Math.floor(operation.x)
  $: operation.width = Math.floor(operation.width)
  $: operation.height = Math.floor(operation.height)
  // $: operation.inputY = Math.floor(operation.inputY)

  $: changeInputY(operation.y)

  const changeInputY = (y) => {
    operation.inputY = Math.floor($BadgeState.baseInfo.height - y)
  }

  // $: checkScaleChange(scale)

  // const checkScaleChange = (scale) => {
  //   if (operation.type == "shape") {
  //     // let prevCenterX = operation.x + operation.scale * 200
  //     // let prevCenterY = operation.y + operation.scale * 200
  //     // operation.x = prevCenterX - scale * 200
  //     // operation.y = prevCenterY - scale * 200
  //     operation.scale = scale
  //   }
  // }

  const moveCursor = (id) => {
    $BadgeState.operations = $BadgeState.operations.map((operation) => {
      operation.move = false
      if (operation.id == id) {
        $BadgeState.cursorPosition.x = operation.x
        $BadgeState.cursorPosition.y = operation.y
        operation.move = true
      }
      return operation
    })
  }
  $: if (operation.move) {
    operation.x = $BadgeState.cursorPosition.x
    operation.y = $BadgeState.cursorPosition.y
  }
  const preventKeys = (e) => {
    const KEYS_TO_PREVENT = ["-", "+", "e", "E"]
    if (KEYS_TO_PREVENT.includes(e.key)) e.preventDefault()
  }
</script>

<svelte:window on:keydown />

<div class="flex w-full flex-col gap-3 rounded-md bg-[#292A2F] p-6 {!operation.value.trim() ? 'border-yellow-500' : ''} {operation.active ? 'border-extraBlue-500' : 'border-transparent'} border">
  <div class="flex flex-col gap-3">
    <!-- <div class="group relative w-full rounded-md">
      <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00">NAME</div>
      <input type="text" value="Shape layer" required class="invalid:animate-shake w-full select-none truncate rounded-md border border-stone-700 bg-transparent py-2 pl-16 pr-10 text-sm text-white outline-none focus:ring-1 focus:ring-extraBlue-500" />
      <div class="absolute right-3 top-2.5 select-none text-sm font-bold text-white">
        <div class="cursor-pointer" data-tooltip="Use attribute" tooltip-position="left">
          <i class="fa-solid fa-brackets-curly" />
        </div>
      </div>
    </div> -->
    <div class="group relative w-full rounded-md">
      <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">TITLE</div>
      <input
        type="text"
        on:keydown={(e) => {
          if (e.key == "Delete") {
            e.stopPropagation()
          }
        }}
        bind:value={operation.value}
        placeholder="Enter the value"
        class="w-full rounded-md border border-stone-700 bg-transparent py-2 pl-16 text-sm text-white outline-none focus:ring-1 focus:ring-extraBlue-500"
      />
    </div>
    <div class="flex gap-3">
      <!-- input x -->
      <div class="group relative w-full rounded-md">
        <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">X</div>
        <button
          on:click|preventDefault={() => {
            if (operation.x + 10 <= $BadgeState.baseInfo.width) {
              operation.x = operation.x + 10
            } else {
              operation.x = $BadgeState.baseInfo.width // Stop at the width boundary
            }
          }}
          class="peer absolute right-2 top-0 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
        >
          <i class="fa-solid fa-chevron-up fa-xs" />
        </button>
        <button
          on:click|preventDefault={() => {
            if (operation.x - 10 >= 0) {
              operation.x = operation.x - 10
            } else {
              operation.x = 0 // Stop at the left boundary
            }
          }}
          class="peer absolute bottom-0 right-2 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
        >
          <i class="fa-solid fa-chevron-down fa-xs" />
        </button>
        <input
          min="0"
          on:keydown={(e) => {
            if (e.key == "Delete") {
              e.stopPropagation()
            }
          }}
          on:keypress={preventKeys}
          type="number"
          bind:value={operation.x}
          class="w-full select-none rounded-md border border-stone-700 bg-transparent py-2 pr-8 pl-10 text-sm text-white outline-none focus:ring-1 focus:ring-extraBlue-500 peer-focus:ring-1 peer-focus:ring-extraBlue-500"
          placeholder="10"
        />
      </div>
      <!-- input y -->

      <div class="group relative w-full rounded-md">
        <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">Y</div>
        <button
          on:click={() => {
            if (operation.y - 10 >= 0) {
              operation.y = operation.y - 10
            } else {
              operation.y = 0 // Stop at the top boundary
            }
          }}
          class="peer absolute right-2 top-0 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
        >
          <i class="fa-solid fa-chevron-up fa-xs" />
        </button>
        <button
          on:click={() => {
            if (operation.y + 10 <= $BadgeState.baseInfo.height) {
              operation.y = operation.y + 10
            } else {
              operation.y = $BadgeState.baseInfo.height // Stop at the bottom boundary
            }
          }}
          class="peer absolute bottom-0 right-2 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
        >
          <i class="fa-solid fa-chevron-down fa-xs" />
        </button>
        <input
          min="0"
          on:input={(e) => {
            operation.y = $BadgeState.baseInfo.height - e.target.value
            // operation.inputY = e.target.value
            // document.getElementById("yinput").value = e.target.value
          }}
          bind:value={operation.inputY}
          on:keydown={(e) => {
            if (e.key == "Delete") {
              e.stopPropagation()
            }
          }}
          on:keypress={preventKeys}
          type="number"
          class="w-full select-none rounded-md border border-stone-700 bg-transparent py-2 pl-10 pr-8 text-sm text-white outline-none focus:ring-1 focus:ring-extraBlue-500 peer-focus:ring-1 peer-focus:ring-extraBlue-500"
          placeholder="10"
        />
      </div>

      <button on:click={() => moveCursor(operation.id)} data-tooltip="Move" tooltip-position="top" class="flex items-center rounded-md border border-stone-700 bg-transparent p-2 text-lg text-gray-g00 hover:bg-zinc-900 focus:outline-none focus:ring-1 focus:ring-extraBlue-500 active:bg-extraBlue-500">
        <span class="flex h-5 w-5 items-center justify-center">
          <i class="fa-solid fa-arrow-pointer" />
        </span>
      </button>
    </div>

    <div class="flex gap-3">
      <!-- Width -->
      <div class="group relative w-full rounded-md">
        <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">W</div>
        <button
          on:click={async () => {
            operation.width = operation.width + 10
            if (maintainAspectRatio && operation.width) {
              operation.height = Math.floor(operation.width / aspectRatio)
            }
          }}
          class="peer absolute right-2 top-0 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
        >
          <i class="fa-solid fa-chevron-up fa-xs" />
        </button>
        <button
          on:click={async () => {
            operation.width = operation.width - 10
            if (maintainAspectRatio && operation.width) {
              operation.height = Math.floor(operation.width / aspectRatio)
            }
          }}
          class="peer absolute bottom-0 right-2 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
        >
          <i class="fa-solid fa-chevron-down fa-xs" />
        </button>
        <input
          min="1"
          max="100000"
          on:input={async (e) => {
            if (maintainAspectRatio && e.target.value) {
              operation.height = Math.floor(e.target.value / aspectRatio)
            }
            operation.width = e.target.value
          }}
          on:keydown={(e) => {
            if (e.key == "Delete") {
              e.stopPropagation()
            }
          }}
          bind:value={operation.width}
          on:keypress={preventKeys}
          type="number"
          class="w-full select-none rounded-md border border-stone-700 bg-transparent py-2 pr-8 pl-10 text-sm text-white outline-none focus:ring-1 focus:ring-extraBlue-500 peer-focus:ring-1 peer-focus:ring-extraBlue-500"
          placeholder="10"
        />
      </div>
      <!-- Height -->

      <div class="group relative w-full rounded-md">
        <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">H</div>
        <button
          on:click={async () => {
            operation.height = operation.height + 10
            if (maintainAspectRatio && operation.height) {
              operation.width = Math.floor(aspectRatio * operation.height)
            }
          }}
          class="peer absolute right-2 top-0 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
        >
          <i class="fa-solid fa-chevron-up fa-xs" />
        </button>
        <button
          on:click={async (e) => {
            operation.height = operation.height - 10
            if (maintainAspectRatio && operation.height) {
              operation.width = Math.floor(aspectRatio * operation.height)
            }
          }}
          class="peer absolute bottom-0 right-2 cursor-pointer text-gray-g00 outline-none hover:text-extraBlue-500"
        >
          <i class="fa-solid fa-chevron-down fa-xs" />
        </button>
        <input
          min="1"
          max="100000"
          on:input={async (e) => {
            if (maintainAspectRatio && e.target.value) {
              operation.width = Math.floor(aspectRatio * e.target.value)
            }
            operation.height = e.target.value
          }}
          on:keydown={(e) => {
            if (e.key == "Delete") {
              e.stopPropagation()
            }
          }}
          on:keypress={preventKeys}
          bind:value={operation.height}
          type="number"
          class="w-full select-none rounded-md border border-stone-700 bg-transparent py-2 pl-10 pr-8 text-sm text-white outline-none focus:ring-1 focus:ring-extraBlue-500 peer-focus:ring-1 peer-focus:ring-extraBlue-500"
          placeholder="10"
        />
      </div>

      <button
        type="button"
        on:click={() => {
          maintainAspectRatio = !maintainAspectRatio
          if (maintainAspectRatio) aspectRatio = operation.width / operation.height
        }}
        data-tooltip="Aspect"
        tooltip-position="top"
        class="{maintainAspectRatio ? 'bg-blue-500 text-white' : 'bg-transparent text-gray-g00'} flex items-center rounded-md border border-stone-700 p-2 text-lg hover:bg-zinc-900 focus:outline-none focus:ring-2 focus:ring-extraBlue-500 active:bg-extraBlue-500 disabled:cursor-not-allowed"
      >
        <span class="flex h-5 w-5 items-center justify-center">
          <i class="fa-solid fa-link-simple" />
        </span>
      </button>
    </div>
    <!-- <div class="flex flex-col gap-1.5">
      <h1 class="text-left text-sm font-medium text-gray-500">Change Size</h1>
      <div class="flex w-full items-center gap-3">
        <h1 class="w-20 select-none text-xl font-bold tracking-wide text-extraBlue-500">{Math.round(operation.scale * 100)}%</h1>
        <input min="0" max="1" step="0.01" bind:value={operation.scale} type="range" class="w-full cursor-pointer outline-none" />
      </div>
    </div> -->
    <div class="flex flex-col gap-1.5">
      <h1 class="text-left text-sm font-medium text-gray-500">Rotation angle (degree)</h1>
      <div class="flex w-full items-center gap-3">
        <input
          min="0"
          max="360"
          step="1"
          on:input={(e) => {
            if (!e.target.value) operation.rotation = 0
            else if (e.target.value > 360) operation.rotation = 360
            else if (e.target.value < 0) operation.rotation = 0
          }}
          on:keydown={(e) => {
            if (e.key == "Delete") {
              e.stopPropagation()
            }
          }}
          on:keypress={preventKeys}
          bind:value={operation.rotation}
          type="number"
          class="w-fit select-none rounded-md border border-stone-700 bg-transparent py-2 px-3 text-sm text-white outline-none focus:ring-1 focus:ring-extraBlue-500 peer-focus:ring-1 peer-focus:ring-extraBlue-500"
          placeholder="10"
        />
        <!-- <h1 class="w-20 select-none text-xl font-bold tracking-wide text-extraBlue-500">{operation.rotation ? Math.round(operation.rotation) : 0}°</h1> -->
        <input min="0" max="360" step="1" bind:value={operation.rotation} type="range" class="w-full cursor-pointer outline-none" />
      </div>
    </div>
  </div>
  <div class="flex items-center gap-3">
    <!-- Canvas Section (Left Half) -->
    <div class="w-1/4">
      <PreviewShapes {operation} />
    </div>

    <!-- Controls Section (Right Half) -->
    <div class="flex w-3/4 flex-col gap-3">
      <div class="flex flex-wrap gap-4">
        {#each operation.data as layer (layer.id)}
          <div class="flex flex-col items-center gap-2">
            <button class="relative flex items-center justify-center rounded-full bg-gray-100 shadow-sm hover:bg-gray-700">
              <button style="background-color: {layer.fill}" class="flex h-6 w-10 items-center justify-center rounded outline-none hover:scale-110" />
              <input on:input={(e) => (layer.fill = e.target.value)} type="color" class="absolute inset-0 h-full w-full cursor-pointer opacity-0" />
            </button>
          </div>
        {/each}
      </div>
      <Button on:click text="Change {operation.type == 'shape' ? 'Shape' : 'Ribbon'}" addClass="bg-yellow-500" iconClass="fa-rotate-right" />
    </div>
  </div>
</div>

<style lang="postcss">
  .inputCls {
    @apply block w-full appearance-none rounded-md border border-slate-500 bg-transparent py-2 text-sm text-white placeholder-gray-400 caret-white outline-none focus:border-extraBlue-500 focus:ring-1 focus:ring-extraBlue-500;
  }
</style>
